import React from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  UtilityText,
  TextAction,
  Modal,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../types/forms-library.types';

export function FraudModal(props: any) {
  const { fraudLabel } = props;

  const fraudIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.FRAUD_ICON);
  return (
    <Modal.Root>
      <Modal.Trigger>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              position: 'relative',
            } as GDSStyleObject
          }
        >
          <TextAction
            css={{
              padding: '$two $none',
            }}
            icon={fraudIcon as string}
            size={{
              '@initial': 'large',
              '@mobile': 'medium',
              '@tablet': 'large',
            }}
            as="button"
          >
            {fraudLabel}
          </TextAction>
        </Box>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 800, '@mobile': '100%' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ alignItems: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              Fraud and Discrimination Disclaimers
            </HeadingText>
          </Modal.Title>
          <UtilityText
            css={{ maxWidth: '600px', maxHeight: '500px', overflowY: 'scroll' }}
          >
            <p>
              Any person who knowingly and with intent to defraud any insurance
              company or other person files an application for insurance or
              statement of claim containing any materially false information or
              conceals for the purpose of misleading, information concerning any
              fact material thereto, commits a fraudulent insurance act which is
              a crime and subjects such person to criminal and civil penalties.
            </p>
            <p>
              CA: For your protection California law requires that the following
              appear on the form: Any person who knowingly presents a false
              claim for the payment of a loss is guilty of a crime and may be
              subject to fines and confinement in state prison.
            </p>
            <p>
              DC & RI: Any person who knowingly presents a false or fraudulent
              claim for payment of a loss or benefit or knowingly presents false
              information in an application for insurance is guilty of a crime
              and may be subject to fines and confinement in prison.
            </p>
            <p>
              FL: Any person who knowingly, and with intent to injure, defraud,
              or deceive any insurer files a statement of claim or an
              application containing any false, incomplete or misleading
              information is guilty of a felony in the third degree.
            </p>
            <p>
              IN & OK: WARNING: Any person who knowingly, and with intent to
              injure, defraud or deceive an insurer, makes any claim for the
              proceeds of an insurance policy containing any false, incomplete
              or misleading information is guilty of a felony.
            </p>
            <p>
              KY: Any person who knowingly and with intent to defraud any
              insurance company or other person files a statement of claim
              containing any materially false information or conceals, for the
              purpose of misleading, information concerning any fact material
              thereto commits a fraudulent insurance act, which is a crime.
            </p>
            <p>
              LA: Any person who knowingly presents a false or fraudulent claim
              for payment of a loss or benefit or knowingly presents false
              information in an application for insurance is guilty of a crime
              and may be subject to fines and confinement in prison.
            </p>
            <p>
              NJ: Any person who knowingly files a statement of claim containing
              any false or misleading information is subject to criminal and
              civil penalties.
            </p>
            <p>
              NY: Any person who knowingly and with intent to defraud any
              insurance company or other person files an application for
              insurance or statement of claim containing any materially false
              information, or conceals for the purpose of misleading,
              information concerning any fact material thereto, commits a
              fraudulent insurance act, which is a crime, and shall also be
              subject to a civil penalty not to exceed five thousand dollars and
              the stated value of the claim for each such violation.
            </p>
            <p>
              VA: Any person who within the intent to defraud or knowing that he
              is facilitating a fraud against an insurer, submits an application
              or files a claim containing a false or deceptive statement may
              have violated the state law.
            </p>
            <p>
              TN & WA: It is a crime to knowingly provide false, incomplete or
              misleading information to an insurance company for the purpose of
              defrauding the company. Penalties include imprisonment, fines and
              denial of insurance benefits.
            </p>
            <p>
              MD: Any person who knowingly or willfully presents a false or
              fraudulent claim for payment of a loss or benefit or who knowingly
              or willfully presents false information in an application for
              insurance is guilty of a crime and may be subject to fines and
              confinement in prison.
            </p>
          </UtilityText>
          <Modal.Close>
            <TextAction
              css={{
                flexDirection: 'column',
                padding: '$one $none',
              }}
              as="button"
            >
              Close
            </TextAction>
          </Modal.Close>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
